export type UNAUTHORIZED_TYPE = 'UNAUTHORIZED';
export type AUTHORIZED_TYPE = 'AUTHORIZED';

export type HIDE_TYPE = 'HIDE';
export type REDIRECT_TYPE = 'REDIRECT';

export const UNAUTHORIZED: UNAUTHORIZED_TYPE = 'UNAUTHORIZED';
export const AUTHORIZED: AUTHORIZED_TYPE = 'AUTHORIZED';

export const HIDE: HIDE_TYPE = 'HIDE';
export const REDIRECT: REDIRECT_TYPE = 'REDIRECT';

export type AuthConditionResponseTypes =
  | REDIRECT_TYPE
  | HIDE_TYPE
  | AUTHORIZED_TYPE
  | UNAUTHORIZED_TYPE;
